import * as _ from 'lodash';

export function showFieldBasedOnConfig(config, path, fieldName, defaultVal){
	const allowed = _.get(config, path);
	if(!allowed) return defaultVal;
	if(Array.isArray(allowed)) return allowed.includes(fieldName);
	return defaultVal; // gestire altri tipi di config non array??
}
